import { Component, OnInit, OnDestroy } from "@angular/core";
import { EvsUserService } from "../../../../common/services/EvsUser.service";
import { EvsErr } from "../evsErr";
import { ToastrService } from "ngx-toastr";
import { ModalSetRoleComponent } from "./modalSetRole.component";
import { ModalManagerComponent } from "./modal-manager/modal-manager.component";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { ConfirmationService } from "primeng/primeng";
import { Subscription } from "rxjs/Rx";
import { ImageService } from "../../../imageService";
import { PagerService } from '../../../../common/services/Pagination.service';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: "evs-staff-list",
  templateUrl: "staff-list.template.html",
  styles: [
    `
      #formCreate .form-group {
        position: relative;
        padding-bottom: 20px;
      }
      #formCreate .form-group small {
        position: absolute;
        bottom: 0;
      }
      /deep/ .modal-super-lg {
        max-width: 1200px;
      }

      /deep/ .ui-widget-overlay.ui-dialog-mask {
        z-index: 1699 !important;
      }
      /deep/ p-confirmdialog div {
        z-index: 3001 !important;
      }

      .special-label {
        width: 100px;
        text-align: left !important;
      }
    `,
  ],
  providers: [EvsUserService, ImageService],
})
export class StaffListComponent implements OnInit, OnDestroy {
  title: string;
  avt_placeholder = "/assets/images/avatar-placeholder.png";
  message: any = { content: "", class: "" };
  public listStaff: any;
  public listStaffCount: number;
  public model: any = {};
  public modelSearch: any = {};
  bsModalRef: BsModalRef;

  uId: any = null;
  u_name: string = null;
  pass_resset: string = null;
  permission: boolean = false;
  subscribe: Subscription;
  langChangeSub: Subscription;
  public user: any = {};
  public modelUpdate: any = {};
  public modalStaff: BsModalRef;

  public item_active: any = 0;
  public pager: any;
  public currentPage: number = 1;
  public pageSize: number = 10;
  public totalPage: number = 0;
  public active: number;


  constructor(
    private userService: EvsUserService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private confirmationService: ConfirmationService,
    private imageService: ImageService,
    private pagerService: PagerService,
    private translate: TranslateService
  ) {
    this.subscribe = this.modalService.onHidden.subscribe(() => {
      this.getStaffList(this.active);
    });
  }

  transform(value: any, args: any[] = null): any {
    return Object.keys(value).map((key) => Object.assign({ key }, value[key]));
  }

  ngOnInit() {
    this.title = this.translate.instant('DANH_SACH_NHAN_VIEN');
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.title = this.translate.instant('DANH_SACH_NHAN_VIEN');
    });
    if (localStorage.getItem("User")) {
      this.user = JSON.parse(localStorage.getItem("User"));
      console.log(this.user);
    }
    this.getStaffList(this.active = 1);
  }
  ngOnDestroy() {
    this.subscribe.unsubscribe();
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  setPage(page: number) {
    // this.item_active = 0;
    if (page <= this.totalPage) {
      if (page < 1) {
        this.currentPage = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.getStaffList(this.active);
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  confirm_delete(id?: any, name?: any) {
    // console.log(id);
    this.confirmationService.confirm({
      message:
        `
                  <div class="text-center font-size-18 text-danger">
                    ` + this.translate.instant('XAC_NHAN_XOA_NHAN_VIEN_COLON') + `<br> "<strong>` +
        name +
        `</strong>"
                  </div>
              `,
      header: this.translate.instant('XOA_NHAN_VIEN'),
      // icon: 'wb-payment',
      accept: () => {
        this.userService.delete_account(id).subscribe(
          (res: any) => {
            let that = this;
            if (res.error === false) {
              let mess = this.translate.instant('THAO_TAC_XOA_NHAN_VIEN_THANH_CONG');
              this.toastr.success(mess, this.translate.instant('THANH_CONG_COLON'), {
                timeOut: 4000,
                positionClass: "toast-top-right",
              });
              $(".staff-id-" + id).fadeOut(500, function () {
                $(".staff-id-" + id).remove();
                that.listStaff.find((x) => x.id == id).deleted_at = 1;
                // that.listStaff[id].deleted_at =  1;
              });
            } else {
              let mess = res.message
                ? res.message
                : this.translate.instant('THAO_TAC_CHUA_THANH_CONG_VUI_LONG_THU_LAI_SAU');
              this.toastr.warning(mess, this.translate.instant('THONG_BAO_COLON'), {
                timeOut: 4000,
                positionClass: "toast-top-right",
              });
            }
          },
          (err: any) => {
            let mess = err.message
              ? err.message
              : this.translate.instant('THAO_TAC_CHUA_THANH_CONG_VUI_LONG_THU_LAI_SAU');
            this.toastr.error(mess, this.translate.instant('THONG_BAO_COLON'), {
              timeOut: 4000,
              positionClass: "toast-top-right",
            });
          }
        );
      },
    });
  }

  modal_reset_password(user_id, name) {
    this.pass_resset = null;
    this.uId = user_id;
    this.u_name = name;
    $("#reset-password").modal();
  }

  submit_reset_password(data) {
    this.userService
      .reset_password(data.user_id, { password: data.reset_password })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          $("#reset-password").modal("hide");
          this.toastr.success(this.translate.instant('DOI_MAT_KHAU_THANH_CONG'), this.translate.instant('THONG_BAO_COLON'), {
            timeOut: 2000,
            positionClass: "toast-top-right",
          });
        } else {
          this.toastr.warning(
            this.translate.instant('DOI_MAT_KHAU_KHONG_THANH_CONG'),
            this.translate.instant('KHONG_THANH_CONG_COLON'),
            {
              timeOut: 2000,
              positionClass: "toast-top-right",
            }
          );
          console.log("reset_password:error", res);
        }
      })
      .catch((err: any) => {
        this.toastr.warning(err.message, this.translate.instant('KHONG_THANH_CONG_COLON'), {
          timeOut: 2000,
          positionClass: "toast-top-right",
        });
        console.log("reset_password:catch", err);
      });
  }

  getStaffList(active) {
    let offset = this.pageSize * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    let limit = this.pageSize;
    this.userService
      .getListStaff({ desc: "id", limit, offset, active })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.listStaff = res.data.staffs;
          this.listStaffCount = res.data.count.count;
          this.totalPage = Math.ceil(res.data.count.count / this.pageSize);
          console.log(this.listStaffCount + "asdasd: " + this.totalPage)
          for (let i = 0; i < this.listStaff.length; i++) {
            this.listStaff[i].avatar = this.imageService.readSrcImage(
              this.listStaff[i].avatar,
              "thumb_large"
            );
          }
          if (res.data.permission == true) {
            this.permission = true;
          } else {
            this.permission = false;
          }
        } else {
          EvsErr.evs_err(res, false);
        }
      })
      .catch((err: any) => {
        EvsErr.evs_err(err);
      });
  }


  onSubmitSearch() {
    let offset =
      this.pageSize * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    let limit = this.pageSize;
    this.userService
      .getListStaff({ name: this.modelSearch.name.trim(), desc: "id", limit, offset })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.listStaff = res.data.staffs;
          this.totalPage = Math.ceil(res.data.count.count / this.pageSize);
          for (let i = 0; i < this.listStaff.length; i++) {
            this.listStaff[i].avatar = this.imageService.readSrcImage(
              this.listStaff[i].avatar,
              "thumb_large"
            );
          }
          if (res.data.permission == true) {
            this.permission = true;
          } else {
            this.permission = false;
          }
        } else {
          EvsErr.evs_err(res, false);
        }
      })
      .catch((err: any) => {
        EvsErr.evs_err(err);
      });
  }

  onSubmit(data) {
    let request: any = {};
    request.username = data._username;
    request.password = data._password;
    request.name = data.name;
    if (this.model.address) request.address = this.model.address;
    if (this.model.phone) request.phone = this.model.phone;
    if (this.model.email) request.email = this.model.email;
    if (this.model.website) request.website = this.model.website;
    this.userService
      .createStaff(request)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let newStaff = res.data;
          this.listStaff.unshift(newStaff);
          this.toastr.success(this.translate.instant('THEM_MOI_NHAN_VIEN_THANH_CONG'), this.translate.instant('THONG_BAO_COLON'), {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
        } else {
          this.toastr.warning(res.message, this.translate.instant('THONG_BAO_COLON'), {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
          // console.log('createAccount:catch', res);
        }
      })
      .catch((err: any) => {
        this.toastr.warning(err.message, this.translate.instant('THONG_BAO_COLON'), {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
        console.log("createAccount:catch", err);
      });
  }

  showModalManager(id) {
    let user: any;
    user = this.listStaff.find((x) => x.id == id);
    const initialState = {
      user: user,
    };
    this.bsModalRef = this.modalService.show(ModalManagerComponent, {
      initialState,
      class: "modal-super-lg",
    });
    this.bsModalRef.content.closeBtnName = "đóng";
  }
  showModalSetRole(id) {
    let user: any;
    user = this.listStaff.find((x) => x.id == id);
    const initialState = {
      user: user,
    };
    this.bsModalRef = this.modalService.show(ModalSetRoleComponent, {
      initialState,
      class: "modal-lg",
    });
  }

  undeleteStaff(id: any, name: string) {
    this.confirmationService.confirm({
      message:
        `
                  <div class="text-center font-size-18 text-danger">
                    ` + this.translate.instant('XAC_NHAN_KHOI_PHUC_LAI_NHAN_VIEN_COLON') + `<br> "<strong>` +
        name +
        `</strong>"
                  </div>
              `,
      header: this.translate.instant('KHOI_PHUC_NHAN_VIEN'),
      // icon: 'wb-payment',
      accept: () => {
        this.userService.undeleted_staff(id).subscribe(
          (res: any) => {
            let that = this;
            if (res.error === false) {
              let mess = this.translate.instant('THAO_TAC_KHOI_PHUC_NHAN_VIEN_THANH_CONG');
              this.toastr.success(mess, this.translate.instant('THANH_CONG_COLON'), {
                timeOut: 4000,
                positionClass: "toast-top-right",
              });
              $(".staff-id-" + id).fadeOut(500, function () {
                $(".staff-id-" + id).remove();
                that.listStaff.find((x) => x.id == id).deleted_at = null;
              });
            } else {
              let mess = res.message
                ? res.message
                : this.translate.instant('THAO_TAC_CHUA_THANH_CONG_VUI_LONG_THU_LAI_SAU');
              this.toastr.warning(mess, this.translate.instant('THONG_BAO_COLON'), {
                timeOut: 4000,
                positionClass: "toast-top-right",
              });
            }
          },
          (err: any) => {
            let mess = err.message
              ? err.message
              : this.translate.instant('THAO_TAC_CHUA_THANH_CONG_VUI_LONG_THU_LAI_SAU');
            this.toastr.error(mess, this.translate.instant('THONG_BAO_COLON'), {
              timeOut: 4000,
              positionClass: "toast-top-right",
            });
          }
        );
      },
    });
  }

  openModalUpdate(template, staff) {
    this.modelUpdate = staff;
    console.log(staff);
    this.modalStaff = this.modalService.show(template);
  }

  updateStaff() {
    let payload = {};
    if (this.modelUpdate.address) payload["address"] = this.modelUpdate.address;
    if (this.modelUpdate.phone) payload["phone"] = this.modelUpdate.phone;
    if (this.modelUpdate.email) payload["email"] = this.modelUpdate.email;
    if (this.modelUpdate.address) payload["website"] = this.modelUpdate.website;
    this.userService
      .updateStaff(this.modelUpdate.id, payload)
      .subscribe((res) => {
        if (res.error === false) {
          this.toastr.success(this.translate.instant('CAP_NHAT_THANH_CONG'), this.translate.instant('THANH_CONG_COLON'), {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
          this.modalStaff.hide();
        } else {
          this.toastr.warning(res.nessage, this.translate.instant('THONG_BAO_COLON'), {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
        }
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/staff-list.component.ts